export const SAVE_TEMP_DATA = 'SAVE_TEMP_DATA'
export const LOAD_TEMP_DATA = 'LOAD_TEMP_DATA'
